var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUpLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2.5C12.5523 2.5 13 2.94772 13 3.5L13 21.5C13 22.0523 12.5523 22.5 12 22.5C11.4477 22.5 11 22.0523 11 21.5L11 3.5C11 2.94772 11.4477 2.5 12 2.5Z",
    fill: "#12131A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2929 2.79289C11.6834 2.40237 12.3166 2.40237 12.7071 2.79289L19.7071 9.79289C20.0976 10.1834 20.0976 10.8166 19.7071 11.2071C19.3166 11.5976 18.6834 11.5976 18.2929 11.2071L12 4.91421L5.70711 11.2071C5.31658 11.5976 4.68342 11.5976 4.29289 11.2071C3.90237 10.8166 3.90237 10.1834 4.29289 9.79289L11.2929 2.79289Z",
    fill: "#12131A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpLine);
export default __webpack_public_path__ + "static/media/arrow-up-line.4de5b8e291245a460e3f09060cca29ad.svg";
export { ForwardRef as ReactComponent };